import {
  Factory, Snowflake, Wind, Flame, Thermometer, Waves, Box, Cog, Droplets,
  Fan, ArrowUpDown, Gauge, ClipboardList, Building2, Hospital, ShoppingCart,
  Warehouse, Briefcase, Store, Hotel, UtensilsCrossed, Cpu, Home, Shield,
  Sun, Sparkles, Snowflake as Snow, Layers,
} from "lucide-react";

export const industryTopics = [
  { icon: Flame, title: "Récupération de chaleur", desc: "Captez et valorisez l'énergie thermique fatale de vos procédés." },
  { icon: Snowflake, title: "Groupes froids", desc: "Modernisation des installations frigorifiques (CO₂, NH₃, HFO)." },
  { icon: Wind, title: "Air comprimé", desc: "Variation de vitesse, traque des fuites, récupération de chaleur." },
  { icon: Factory, title: "Fours industriels", desc: "Isolation, combustion contrôlée, électrification des procédés." },
  { icon: Thermometer, title: "Chaudières", desc: "Condensation, économiseurs, biomasse, régulation avancée." },
  { icon: Waves, title: "Réseaux vapeur", desc: "Calorifugeage, purgeurs, retour de condensats, traque des pertes." },
  { icon: Box, title: "CTA & traitement d'air", desc: "Récupération de chaleur sur air vicié, moteurs EC, free-cooling." },
  { icon: Cog, title: "Moteurs & variateurs", desc: "Remplacement IE4/IE5, variation de vitesse, sous-comptage." },
  { icon: Droplets, title: "Pompes & circulateurs", desc: "Optimisation hydraulique, drives intelligents, monitoring." },
  { icon: Fan, title: "Ventilation industrielle", desc: "Stratégies à la demande, qualité d'air, performance énergétique." },
  { icon: ArrowUpDown, title: "Déstratification", desc: "Brassage haute performance pour grands volumes & entrepôts." },
  { icon: Gauge, title: "Optimisation énergétique", desc: "Sous-comptage, monitoring temps réel, ISO 50001." },
  { icon: ClipboardList, title: "Audits énergétiques", desc: "Diagnostics réglementaires & audits CEE spécifiques." },
];

export const commercialTopics = [
  { icon: Hotel, title: "Hôtels" },
  { icon: Hospital, title: "Hôpitaux & cliniques" },
  { icon: ShoppingCart, title: "Supermarchés" },
  { icon: Warehouse, title: "Entrepôts logistiques" },
  { icon: Briefcase, title: "Immeubles de bureaux" },
  { icon: Store, title: "Centres commerciaux" },
  { icon: Waves, title: "Piscines & centres aquatiques" },
  { icon: UtensilsCrossed, title: "Restaurants & restauration collective" },
  { icon: Snowflake, title: "Réfrigération commerciale" },
  { icon: Flame, title: "Chauffage & PAC" },
  { icon: Fan, title: "Ventilation & CTA" },
  { icon: Cpu, title: "GTB / GTC" },
  { icon: Thermometer, title: "Récupération de chaleur" },
  { icon: Shield, title: "Éclairage performant" },
];

export const residentialTopics = [
  { icon: Layers, title: "Isolation thermique", desc: "Murs, combles, planchers, ITE — éliminez les déperditions." },
  { icon: Thermometer, title: "Pompes à chaleur", desc: "Air/eau, eau/eau, hybrides — coup de pouce CEE inclus." },
  { icon: Droplets, title: "Chauffe-eau thermodynamiques", desc: "Jusqu'à 70 % d'économies sur l'eau chaude sanitaire." },
  { icon: Fan, title: "Ventilation (VMC)", desc: "Double flux avec récupération haute performance." },
  { icon: Flame, title: "Systèmes de chauffage", desc: "Chaudières condensation, hybrides, gaz vert." },
  { icon: Sparkles, title: "Rénovation globale", desc: "Programmes coordonnés clé en main pour copropriétés." },
  { icon: Sun, title: "Aides & primes CEE", desc: "MaPrimeRénov', Coup de Pouce, primes locales optimisées." },
];

export const sectors = [
  {
    id: "industrie",
    title: "Industrie",
    kicker: "01 · Sites industriels",
    blurb: "Optimisez la consommation énergétique de vos procédés grâce aux Certificats d'Économies d'Énergie.",
    image: "https://images.unsplash.com/photo-1716643863806-989dd76ae093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODI3OTA2NDR8MA&ixlib=rb-4.1.0&q=85",
    href: "/industrie",
    icon: Factory,
    bullets: ["Récupération de chaleur", "Groupes froids", "Air comprimé", "Chaudières", "Réseaux vapeur", "Fours industriels", "Moteurs & variateurs", "Optimisation énergétique"],
  },
  {
    id: "tertiaire",
    title: "Tertiaire",
    kicker: "02 · Bâtiments & retail",
    blurb: "Financez l'efficacité énergétique de votre patrimoine tertiaire et commercial.",
    image: "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mjc5MDY0NHww&ixlib=rb-4.1.0&q=85",
    href: "/tertiaire",
    icon: Building2,
    bullets: ["Grandes surfaces", "Hôtels", "Hôpitaux", "Entrepôts", "Bureaux", "Centres commerciaux", "Pompes à chaleur", "GTB · CTA · Ventilation"],
  },
  {
    id: "residentiel",
    title: "Résidentiel",
    kicker: "03 · Habitat & copropriétés",
    blurb: "Profitez des CEE pour réduire votre consommation et améliorer le confort de vos résidences.",
    image: "https://images.pexels.com/photos/9173035/pexels-photo-9173035.jpeg",
    href: "/residentiel",
    icon: Home,
    bullets: ["Pompes à chaleur", "Isolation", "Ventilation", "Chauffage", "Copropriétés", "Bailleurs sociaux", "Résidences collectives"],
  },
];

// Re-export Snow alias (used elsewhere)
export { Snow };
